//Core-Angular
import {
  CurrencyPipe,
  DatePipe,
  DecimalPipe,
  LocationStrategy,
  PathLocationStrategy,
  registerLocaleData,
} from '@angular/common';
import {APP_INITIALIZER, LOCALE_ID, NgModule, inject} from '@angular/core';
import {FormsModule, ReactiveFormsModule, UntypedFormControl, ValidationErrors} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {EmailEditorModule} from 'angular-email-editor';
import {NgCircleProgressModule} from 'ng-circle-progress';

//CoreUI
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap';
import {FORMLY_CONFIG, FormlyModule} from '@ngx-formly/core';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {AppComponent} from './app.component';

// import { NAV_DROPDOWN_DIRECTIVES } from './Core/Abstract/nav-dropdown.directive';
import {provideCharts, withDefaultRegisterables} from 'ng2-charts';
// import { SIDEBAR_TOGGLE_DIRECTIVES } from './Core/Menu/sidebar.directive';
// import { AsideToggleDirective } from './Core/Abstract/aside.directive';
// import { BreadcrumbsComponent } from './Core/Abstract/breadcrumb.component';

//Routing Module
import {AppRoutingModule} from './app.routing';

// Custom Select/Dropdown
// import { SelectModule } from './select';
import {NgSelectModule} from '@ng-select/ng-select';

//Logout Timer
// import { NgIdleModule  } from '@ng-idle/core';

//Pipes
import {SafeHtmlPipe} from './htmlPipe';
import {FilterListPipe} from './pipes';

//Generic Upload Files
import {FileUploadModule} from 'ng2-file-upload';
import {FormlyFieldButton} from './Core/Abstract/CustomFormlyTemplate/formly-field-button';
import {FormlyFieldFile} from './Core/Abstract/CustomFormlyTemplate/formly-field-file';
import {FormlyFieldInput} from './Core/Abstract/CustomFormlyTemplate/formly-field-input';

//Localization (for Pipes)
import localEL from '@angular/common/locales/el';
import localAr from '@angular/common/locales/ar-AE';
import localDE from '@angular/common/locales/de';
import localGB from '@angular/common/locales/en-GB';
import localBH from '@angular/common/locales/ar-BH';

import {RoutingComponent} from './Core/Routes/routing.component';
import {WebXmlComponent} from './Core/Routes/webxml.component';

//login
import {LogInComponent} from './Core/Login/login.component';
import {SingleSignOnComponent} from './Core/Login/sso.component';
// import { PasswordStrengthBarModule } from 'ng2-password-strength-bar';

//Custom - Non grid
//mail
import {ComposeComponent} from './Mail/compose.component';
import {DetailsComponent} from './Mail/details.component';
import {ListComponent} from './Mail/list.component';
import {NavComponent} from './Mail/nav.component';
import {DocumentsComponent} from './Menus/Documents/documents.component';
//upload
import {FileUploaderComponent} from './Menus/FileUploader/fileUploader.component';

//Grids
import {HttpClient, HttpClientModule, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {CurrencyMaskConfig} from 'ng2-currency-mask';
import {AccordionModule} from 'ngx-bootstrap/accordion';
import {AlertModule} from 'ngx-bootstrap/alert';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {FileSaverModule} from 'ngx-filesaver';
import {ToastrModule} from 'ngx-toastr';
import {FormlyFieldRadio} from './Core/Abstract/CustomFormlyTemplate/formly-field-radio';
import {FormlyFieldSelect} from './Core/Abstract/CustomFormlyTemplate/formly-field-select';
import {FormlyFieldTextarea} from './Core/Abstract/CustomFormlyTemplate/formly-field-textarea';
import {PanelDefaultFieldWrapper} from './Core/Abstract/CustomFormlyTemplate/panel-default-wrapper';
import {PanelWrapperComponent} from './Core/Abstract/CustomFormlyTemplate/panel-wrapper.component';
import {RepeatTypeComponent} from './Core/Abstract/FormArray/repeat-section.type';
import {AdminClustersComponent} from './Menus/AdminClusters/adminClusters.component';
import {AdminDocumentTypesComponent} from './Menus/AdminDocumentTypes/adminDocumentTypes.component';
import {AdminTermsAndConditionsComponent} from './Menus/AdminTermsAndConditions/adminTermsAndConditions.component';
import {ApproveClientUploadComponent} from './Menus/ApproveClientUpload/approveClientUpload.component';
import {ApproveClientUploadRowComponent} from './Menus/ApproveClientUploadRow/approveClientUploadRow.component';
import {ApproveDebtorUploadComponent} from './Menus/ApproveDebtorUpload/approveDebtorUpload.component';
import {ApproveDebtorUploadRowComponent} from './Menus/ApproveDebtorUploadRow/approveDebtorUploadRow.component';
import {AuthFlowSetupComponent} from './Menus/AuthFlowSetup/authFlowSetup.component';
import {AuthFlowSetupEditComponent} from './Menus/AuthFlowSetup/authFlowSetupEdit.component';
import {ClaccFinanceRequestComponent} from './Menus/ClaccFinanceRequest/claccFinanceRequest.component';
import {CreditnotesClientBatchComponent} from './Menus/CreditnotesClientBatch/creditnotesClientBatch.component';
import {CreditnotesDebtorBatchComponent} from './Menus/CreditnotesDebtorBatch/creditnotesDebtorBatch.component';
import {DemandApprovalRequestComponent} from './Menus/DemandApprovalRequest/demandApprovalRequest.component';
import {DemandDisputeRequestComponent} from './Menus/DemandDisputeRequest/demandDisputeRequest.component';
import {DemandFinanceRequestComponent} from './Menus/DemandFinanceRequest/demandFinanceRequest.component';
import {FourEyesAdminPanelComponent} from './Menus/FourEyesAdminPanel/fourEyesAdminPanel.component';
import {ComponentRegistryService} from './Menus/Home/RequestsForApproval/component-registry.service';
import {RequestsForApproval} from './Menus/Home/RequestsForApproval/requestsForApproval.component';
import {HomeComponent} from './Menus/Home/home.component';
import {MailTemplateComponent} from './Menus/MailTemplate/mailTemplate.component';
import {NotificationBuilder} from './Menus/NotificationBuilder/notificationBuilder.component';
import {NotificationBuilderDetails} from './Menus/NotificationBuilderDetails/notificationBuilderDetails.component';
import {OnBoardingDocsComponent} from './Menus/OnBoardingDocs/onBoardingDocs.component';
import {OnBoardingDocsAMLComponent} from './Menus/OnBoardingDocsAML/onBoardingDocsAML.component';
import {OnBoardingDocsKYCComponent} from './Menus/OnBoardingDocsKYC/onBoardingDocsKYC.component';
import {PaymentsClientBatchComponent} from './Menus/PaymentsClientBatch/paymentsClientBatch.component';
import {PaymentsDebtorBatchComponent} from './Menus/PaymentsDebtorBatch/paymentsDebtorBatch.component';
import {ReceivablesClientBatchComponent} from './Menus/ReceivablesClientBatch/receivablesClientBatch.component';
import {ReceivablesDebtorBatchComponent} from './Menus/ReceivablesDebtorBatch/receivablesDebtorBatch.component';
import {RepLedgerDemandsComponent} from './Menus/RepLedgerDemands/repLedgerDemands.components';
import {UploadInitationsComponent} from './Menus/ResendInvitation/UploadInvitations/uploadInvitations.component';
import {ResendInvitationComponent} from './Menus/ResendInvitation/resendInvitation.component';
import {ResendInvitationAttachmentComponent} from './Menus/ResendInvitationAttachment/resendInvitationAttachment.component';
import {TrackInvitations} from './Menus/TrackInvitations/trackInvitations.component';
import {fileUploadKycComponent} from './Menus/TrackInvitationsDetails/KYCAML/fileUpload.component';
import {KycAmlComponent} from './Menus/TrackInvitationsDetails/KYCAML/kycAml.component';
import {TrackInvitationsDetails} from './Menus/TrackInvitationsDetails/trackInvitationsDetails.component';
import {ArchwizardModule} from './archwizard/archwizard.module';
import {BreadcrumbsModule} from './core-ui/abstract/breadcrumb/breadcrumb.module';
import {LayoutDirectivesModule} from './core-ui/abstract/directives/layoutdirectives.module';
import {HeaderModule} from './core-ui/abstract/header/header.module';
import {LayoutModule} from './core-ui/abstract/layouts/layout.module';
import {MenuModule} from './core-ui/abstract/menu/menu.module';
import {ConfigService} from './core-ui/abstract/services/config.service';
import {EventsEmitterService} from './core-ui/abstract/services/emitter.service';
import {LogService} from './core-ui/abstract/services/log.service';
import {SecurityService} from './core-ui/abstract/services/security.service';
import {VisualsService} from './core-ui/abstract/services/visuals.service';
import {Ng2DatetimePickerModule} from './core-ui/datepicker';
import {DynamicFormModule} from './core-ui/dynamic-form/dynamic-form.module';
import {DynamicGridModule} from './core-ui/dynamic-grid/dynamic-grid.module';
import { ValidatorsService } from './Core/Abstract/validators/validators.service';
import { showError } from './Core/Abstract/validators/validators';
import { registerValidators } from './validator.extension';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

export function getConfig() {
  const config: ConfigService = inject(ConfigService);
  return () => config.load();
}

export function getLocale(config: ConfigService) {
  if (config.getLocale() == 'el-GR' || config.getLocale() == 'el') {
    registerLocaleData(localEL);
  } else if (config.getLocale() == 'ar-AE') {
    registerLocaleData(localAr);
  }
  else if (config.getLocale() == 'en-GB') {
    registerLocaleData(localGB);
  }
  else if (config.getLocale() == 'de-DE') {
    registerLocaleData(localDE);
  }
  else if (config.getLocale() == 'ar-BH') {
    registerLocaleData(localBH);
  }
  return config.getLocale();
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "/assets/abj/i18n/", ".json");
}


export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'right',
  allowNegative: false,
  decimal: ',',
  precision: 2,
  prefix: '',
  suffix: '',
  thousands: '.',
};

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    TooltipModule.forRoot(),
    AccordionModule.forRoot(),
    HttpClientModule,
    RouterModule,
    FormsModule,
    Ng2DatetimePickerModule,
    ReactiveFormsModule,
    AlertModule.forRoot(),
    NgSelectModule,
    EmailEditorModule,
    FormlyBootstrapModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
      }
  }),
    FormlyModule.forRoot({
      types: [
        {name: 'repeat', component: RepeatTypeComponent},
        {name: 'select', component: FormlyFieldSelect},
        {name: 'radio', component: FormlyFieldRadio},
        {name: 'text', component: FormlyFieldTextarea},
        {name: 'input', component: FormlyFieldInput},
        {name: 'file', component: FormlyFieldFile},
        {name: 'button', component: FormlyFieldButton},
        {name: 'checkbox', defaultOptions: {defaultValue: false}},
      ],
      extras: {showError,immutable: true, resetFieldOnHide: false},

      wrappers: [
        {name: 'panel', component: PanelWrapperComponent},
        {name: 'default-panel', component: PanelDefaultFieldWrapper},
      ],
    }),
    FileUploadModule,
    FileSaverModule,
    HeaderModule,
    BreadcrumbsModule,
    LayoutModule,
    LayoutDirectivesModule,
    MenuModule,
    DynamicGridModule,
    DynamicFormModule,
    ArchwizardModule,
    ToastrModule.forRoot({
      timeOut: 7000,
      newestOnTop: false,
      progressBar: true,
      progressAnimation: 'increasing',
    }),
    NgCircleProgressModule.forRoot({}),
  ],
  providers: [
    {provide: LocationStrategy, useClass: PathLocationStrategy},
    ConfigService,
    EventsEmitterService,
    SecurityService,
    LogService,
    VisualsService,
    WebXmlComponent,
    DatePipe,
    DecimalPipe,
    CurrencyPipe, 
    ValidatorsService,
    provideCharts(withDefaultRegisterables()),
    {
      provide: APP_INITIALIZER,
      useFactory: getConfig,
      deps: [ConfigService],
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useFactory: getLocale,
      deps: [ConfigService],
    },
    { provide: FORMLY_CONFIG, multi: true, useFactory: registerValidators, deps: [ TranslateService,ValidatorsService] }
  ],
  declarations: [
    //Core
    AppComponent,
    RoutingComponent,
    //login
    LogInComponent,
    SingleSignOnComponent,
    //mail
    ListComponent,
    NavComponent,
    DetailsComponent,
    ComposeComponent,
    //Grids
    FormlyFieldSelect,
    FormlyFieldTextarea,
    FormlyFieldFile,
    FormlyFieldButton,
    FormlyFieldInput,
    PanelWrapperComponent,
    RepeatTypeComponent,
    HomeComponent,
    DocumentsComponent,
    DemandApprovalRequestComponent,
    ReceivablesClientBatchComponent,
    ReceivablesDebtorBatchComponent,
    CreditnotesClientBatchComponent,
    CreditnotesDebtorBatchComponent,
    PaymentsClientBatchComponent,
    PaymentsDebtorBatchComponent,
    ApproveClientUploadComponent,
    ApproveClientUploadRowComponent,
    ApproveDebtorUploadComponent,
    ApproveDebtorUploadRowComponent,
    DemandDisputeRequestComponent,
    ClaccFinanceRequestComponent,
    DemandFinanceRequestComponent,
    RepLedgerDemandsComponent,
    TrackInvitations,
    TrackInvitationsDetails,
    NotificationBuilderDetails,
    AdminDocumentTypesComponent,
    ResendInvitationComponent,
    UploadInitationsComponent,
    AdminClustersComponent,
    OnBoardingDocsComponent,
    OnBoardingDocsKYCComponent,
    OnBoardingDocsAMLComponent,
    KycAmlComponent,
    fileUploadKycComponent,
    MailTemplateComponent,
    AuthFlowSetupComponent,
    AuthFlowSetupEditComponent,
    ResendInvitationAttachmentComponent,
    //uploads
    FileUploaderComponent,
    //Pipe
    FilterListPipe,
    SafeHtmlPipe,
    AdminTermsAndConditionsComponent,
    FormlyFieldRadio,
    PanelDefaultFieldWrapper,
    NotificationBuilder,
    NotificationBuilderDetails,
    RequestsForApproval,
    FourEyesAdminPanelComponent,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private componentRegistry: ComponentRegistryService) {
    componentRegistry.registerComponent('adminClusters-grid', AdminClustersComponent, false);
    componentRegistry.registerComponent('adminTermsAndConditions-grid', AdminTermsAndConditionsComponent, false);
    componentRegistry.registerComponent('onBoardingDocs-grid', OnBoardingDocsComponent, false);
    componentRegistry.registerComponent(
      'authFlowSetupEdit-grid', 
      AuthFlowSetupEditComponent, 
      true, 
      'menu/7214', 
      (params) => ({
        actionCd: params.actionCd,
        cmpId: params.cmpId,
        requestId: params.requestId,
        foureyesComparisonId: params.foureyesComparisonId,
        fourEyes: true,
      })
    );

  }
}
